import React, {Component} from 'react'
import PropTypes from 'prop-types'

class Procedure extends Component {
    render() {
        const {procedure} = this.props

        return (
            <td className="Procedure">
                {procedure || '2D'}
            </td>
        )
    }
}

Procedure.propTypes = {
    procedure: PropTypes.string
}

export default Procedure